const apiUrl = process.env.REACT_APP_API_URL;

export const fetchMedicalHistoryByDate = async payload => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/historia_medica_all_fecha`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    throw new Error('Error obtaining medical history');
  }

  return response.json();
};

export const fetchHistoryPrescriptionSurgery = async payload => {
  const response = await fetch(`${apiUrl}/api/historia_receta_cirugia`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('Error obteniendo historia, receta y cirugía');
  }

  return response.json();
};

export const processPaymentRequest = async payload => {
  return await fetch(`${apiUrl}/api/procesar-pago`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};

export const postMedicalHistory = async payload => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/historia_medica`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    throw new Error('Error at post medical history');
  }

  return response.json();
};
